import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type FeeSourceNotificationsEmailConditionId = Branded<
    string,
    "FeeSourceNotificationsEmailConditionId"
>;
const feeSourceNotificationsEmailConditionIdPrefix =
    "fee_source_notifications_email_condition__";
const {
    factory: feeSourceNotificationsEmailConditionIdFactory,
    assert: isFeeSourceNotificationsEmailConditionId,
    zodSchema: feeSourceNotificationsEmailConditionIdZodSchema,
} = genericId<FeeSourceNotificationsEmailConditionId>(
    feeSourceNotificationsEmailConditionIdPrefix,
);

export {
    feeSourceNotificationsEmailConditionIdFactory,
    feeSourceNotificationsEmailConditionIdPrefix,
    feeSourceNotificationsEmailConditionIdZodSchema,
    isFeeSourceNotificationsEmailConditionId,
};
export type { FeeSourceNotificationsEmailConditionId };
